import { jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { productsStore } from "../../../../stores/products/productsStore";
import { postsStore } from "../../../../stores/posts/postsStore";
import { textFieldStyle } from "../../../../assets/styles/styles";
import { useMemo } from "react";
export const ProductSelector = ({ value, onChange, }) => {
    const productMap = productsStore.useProducts();
    const options = useMemo(() => Object.values(productMap), [productMap]);
    return (_jsx(Autocomplete, { sx: {
            maxWidth: 500,
            ...textFieldStyle
        }, multiple: true, limitTags: 3, filterSelectedOptions: true, value: value, options: options, getOptionLabel: (option) => `${option.title} (${option.description})`, onChange: onChange, renderInput: (params) => (_jsx(TextField, { ...params, variant: "standard", label: "Select Product", placeholder: "Products" }, void 0)) }, void 0));
};
export default function SelectProduct() {
    const value = postsStore.useNewPostProducts();
    return (_jsx(ProductSelector, { value: value, onChange: (_event, newValue) => {
            postsStore.setNewPost({ ...postsStore.getNewPost(), products: newValue });
        } }, void 0));
}
//# sourceMappingURL=SelectProduct.js.map